module.exports = __webpack_public_path__ + "static/PMB_footer_cloud_logo-09f32b51528bb8fabaf1dfa2ba87f37b.png";